export const OVER_SPEED = 20;
